// FutureRow.js
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

function FutureRow({ item }) {
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: false });

  return (
    <motion.div
      className="future-row"
      ref={ref}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={itemVariants}
    >
      <div className="problem-box">{item.problem}</div>
      <div className="arrow">➤➤</div>
      <div className="solution-box">
        <div className="icon-circle" />
        <p>{item.solution}</p>
      </div>
    </motion.div>
  );
}

export default FutureRow;
